<template>
  <a-form-model
    style='width: 600px'
    :model='ruleForm'
    :rules='rules'
    ref='form'
    :label-col='{span:4}' :wrapper-col='{span:20}'>
    <a-form-model-item label='建议销售价' prop='advicePrice'>
      <a-input v-model='ruleForm.advicePrice' placeholder='请输入' :maxLength='10' allowClear style='width: 400px'/>
    </a-form-model-item>
    <a-form-model-item label='同行价' prop='peerPrice'>
      <a-input v-model='ruleForm.peerPrice' placeholder='请输入' allowClear style='width: 400px'/>
    </a-form-model-item>
    <a-form-model-item label='佣金' prop='commission'>
      <a-input v-model='ruleForm.commission' placeholder='请输入' allowClear style='width: 400px'/>
    </a-form-model-item>

    <a-form-model-item label='市场价' prop='marketPrice'>
      <span>{{ ruleForm.marketPrice }}</span>
    </a-form-model-item>

    <a-form-model-item label='采购价'>
      <span>{{ ruleForm.purchasePrice }}</span>
    </a-form-model-item>
    <a-form-model-item label='状态' prop='status'>
      <a-radio-group v-model='ruleForm.status'>
        <a-radio :value='1'>上架</a-radio>
        <a-radio :value='0'>下架</a-radio>
      </a-radio-group>

    </a-form-model-item>

    <a-form-model-item
      :wrapper-col='{ span: 14, offset: 4 }'>
      <span>
        <a-button type='primary' @click='onSubmitEvent' :loading='submitLoading'>{{ submitButtonName }}</a-button>
      </span>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
export default {
  name: 'PriceEditorView',
  components: {},
  props: {
    submitLoading: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => new Object()
    },
    submitButtonName: {
      type: String,
      default: '保存'
    }
  },
  data() {
    let pattern = /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/
    return {
      ruleForm: {
        marketPrice: '',

        productId: '',
        advicePrice: '',
        peerPrice: 0,
        commission: 0,
        purchasePrice: 0,
        status: 0
      },
      rules: {
        advicePrice: [
          { required: true, message: '请输入建议销售价', trigger: ['blur', 'change'] },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
          , { validator: this.validatorAdvicePrice, trigger: ['blur', 'change'] }

        ],
        peerPrice: [
          { required: true, message: '请输入同行价', trigger: ['blur', 'change'] },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          }
          , { validator: this.validatorPeerPrice, trigger: ['blur', 'change'] }
        ],
        commission: [
          { required: true, message: '请输入佣金', trigger: ['blur', 'change'] },
          { validator: this.validatorCommission, trigger: ['blur', 'change'] }

        ],
        status: [
          { required: true, message: '请输入选择状态', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  mounted() {
    this.ruleForm = { ...this.value }
  },
  methods: {
    validatorCommission(rule, value, callback) {
      if (String(value) === '0' || /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/.test(value)) {
        if (Math.round(Math.round(Number(this.ruleForm.advicePrice) * 100) - Math.round(Number(this.ruleForm.peerPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于销售价减同行价'))
        } else {
          callback()
        }
      } else {
        callback(new Error('佣金只能是非负数'))
      }
    },
    validatorAdvicePrice(rule, value, callback) {
      if (Number.parseFloat(value) < Number.parseFloat(this.ruleForm.peerPrice)) {
        callback(new Error('销售价必须大于或等于同行价'))
      } else {
        callback()
      }
    },
    validatorPeerPrice(rule, value, callback) {
      if (Number.parseFloat(value) < Number.parseFloat(this.ruleForm.purchasePrice)) {
        callback(new Error('同行价必须大于或等于采购'))
      } else {
        callback()
      }
    },
    onSubmitEvent() {
      this.$refs['form'].validate(valid => {
        console.error('===onSubmitEvent=')
        if (valid) {
          this.$emit('submit', { ...this.ruleForm })
        } else {
          this.$message.error('请完善账号信息')
        }
      })
    }
  }
}
</script>

<style scoped lang='less'>

</style>
